import React from "react";
import { router } from "dva";
import { Affix, Menu, Modal, Badge, Popover } from "antd";
import { BellFilled, DownOutlined } from "@ant-design/icons";

import { template, setLocalStorage, getLocalStorage, getObjectProp, transformAssetsUrl, setCurrentUnit, getCurrentUnitId, getCurrentParkId } from "@reco-m/core";
import { changeUrlParams, mtaH5Click, statisticsEvent, InputDelay, ViewComponent } from "@reco-w/core-ui";

import { CommonSearchParamInUrlEnum } from "@reco-w/common-common";
import { Namespaces, headerModel } from "@reco-w/layout-models";

const { SubMenu } = Menu;
export namespace PageHeader {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, headerModel.StateType {
        navState?: any;
    }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.header;

        excludeSplit = ["/policy?"];

        get logoutRouter() {
            return getObjectProp(client, "logoutRouter", "/login");
        }

        get parkcode() {
            return this.props.match!.params.parkcode;
        }

        get defaultTitle() {
            return getObjectProp(client, "title", "--");
        }

        componentDidMount() {
            this.dispatch({
                type: "initPage",
                inputData: { radioSelect: getCurrentParkId() },
                judgeParkCode: this.parkcode,
            });
            $(window).scroll(() => {
                let top = $(window).scrollTop() as any;
                top >= 83
                    ? this.setState({
                          navState: true,
                      })
                    : this.setState({
                          navState: false,
                      });
            });
        }

        componentReceiveProps(nextProps: P) {
            let isLogin =
                (nextProps.location?.search?.includes("isLogin=") && !this.props.location?.search?.includes("isLogin=")) ||
                (this.props.location?.search?.includes("isLogin=") && !nextProps.location?.search?.includes("isLogin="));

            if (isLogin) {
                this.dispatch({ type: "getCertify" });
            }

            if (nextProps.location?.hash?.includes(this.logoutRouter)) {
                this.goTo(this.logoutRouter);
                window.location.reload();
            }
        }

        componentWillUnmount() {
            this.setState = () => {
                return;
            };
        }

        /**
         * 切换园区
         * @param park
         */
        changePark(park: any, unit) {
            if (unit && unit.id) {
                setCurrentUnit(unit);
            }

            if (park) {
                mtaH5Click(statisticsEvent.parkSwitch);
                setLocalStorage("selectedMenu", "/home"); // 设置被选中的菜单为home

                let parkcode = this.parkCode;
                let router = location.href.split(parkcode);

                this.dispatch({
                    type: "changePark",
                    message: this.message,
                    isLogin: this.isAuth(),
                    park,
                    callback: () => {
                        location.href = `${router[0]}${park.code}${router[1]}`;
                    },
                });
            }
        }

        /**
         * 渲染已登录时的展示按钮
         * @returns auth login
         */
        renderAuthLogin(): React.ReactNode {
            const { state } = this.props,
                user = state!.user;

            return (
                <>
                    <i className="icon iconren2 gray-tow-color size-15 mr3" />
                    <router.Link
                        to={`/${this.parkCode}/my`}
                        onClick={() => {
                            setLocalStorage("selectedMenu", "/my");
                            setLocalStorage("mySelectedMenu", "/my");
                        }}
                    >
                        {user?.nickName || "请设置昵称"}
                    </router.Link>
                    <span className="mh6 text-gray">丨</span>
                    <i className="icon iconzhuxiao gray-tow-color mr3" />
                    <router.Link
                        to={`/${this.parkCode}/login`}
                        onClick={() =>
                            this.dispatch({
                                type: `logout`,
                                success: () => this.goTo(`/${this.parkCode}/login`),
                                error: (e) => Modal.error({ title: "消息提醒", content: e }),
                            })
                        }
                    >
                        注销
                    </router.Link>
                </>
            );
        }

        /**
         * 渲染未登录时的展示按钮
         * @returns unauth login
         */
        renderUnauthLogin(): React.ReactNode {
            return (
                <>
                    <i className="icon iconren2 gray-tow-color size-15 mr3" />
                    <router.Link to={`/${this.parkCode}/login`}> 登录</router.Link>
                    <span className="mh6 text-gray">丨</span>
                    <i className="icon iconbianji gray-tow-color size-15 mr3" />
                    <router.Link to={`/${this.parkCode}/login/register`}>注册</router.Link>
                </>
            );
        }

        /**
         * 渲染登录按钮
         * @returns
         */
        renderLogin(): React.ReactNode {
            return this.isAuth() ? this.renderAuthLogin() : this.renderUnauthLogin();
        }

        /**
         * 渲染消息数量
         */
        renderNotice() {
            const { state } = this.props,
                noticeCount = state!.noticeCount;
            return this.isAuth() ? (
                <a className="margin-right" onClick={() => this.goTo(`/${this.parkCode}/my/mynotice`)}>
                    <BellFilled />
                    <Badge className="ml5" count={noticeCount} size="small"></Badge>
                </a>
            ) : null;
        }

        /**
         * 渲染搜索栏
         * @returns
         */
        renderSearch(): React.ReactNode {
            const { state } = this.props,
                searchKey = state!.searchKey;
            return (
                <div className="home-search">
                    <InputDelay.Component
                        placeholder="输入关键字搜索"
                        style={{ width: 220 }}
                        value={searchKey}
                        onChange={(e) => this.dispatch({ type: "input", data: { searchKey: e.target.value } })}
                        onDelayTrigger={(value) => this.searchKey(value)}
                        hideIcon
                    />
                    <a>
                        <i className="icon iconsousuo"></i>
                    </a>
                </div>
            );
        }

        /**
         * 渲染园区选择
         * @returns parks
         */
        renderParks(): React.ReactNode {
            const { state } = this.props,
                _parkNames = state!.parkNames || [],
                units = state!.units || [],
                radioSelect = getCurrentParkId() || state!.radioSelect,
                unitId = getCurrentUnitId(),
                selectPark = _parkNames.find((x) => x.value === radioSelect);

            const content = (
                <div className="park-select">
                    <div className="park-select-box">
                        {units &&
                            units.length > 0 &&
                            units.map((unit, i) => {
                                return (
                                    <div key={"unit_" + i}>
                                        <div className="margin-v-xs header-unit-name" style={{ fontWeight: "bold" }}>
                                            {unit.shortName || unit.unitName}
                                        </div>
                                        <div>
                                            {unit.parks.map((item) => (
                                                <div key={"unit_" + i} className="park-radio-box" onClick={() => this.changePark(item, unit)}>
                                                    <span className={"park-radio" + (item.value === radioSelect && unitId === unit.id ? " park-radio-checked" : "")}>
                                                        <span className="park-radio-input"></span>
                                                        <span
                                                            className={"park-radio-inner" + (item.value === radioSelect && unitId === unit.id ? " park-radio-inner-checked" : "")}
                                                        ></span>
                                                    </span>
                                                    <span className="park-radio-text">{item.label}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            );

            return (
                <Popover placement="bottom" content={content} title="选择园区" trigger="hover">
                    <div className="ant-select ant-select-borderless ant-select-single ant-select-show-arrow">
                        <div className="ant-select-selector">
                            <span className="ant-select-selection-item" title={selectPark && selectPark.label}>
                                {selectPark && selectPark.label} <DownOutlined style={{ fontSize: "12px" }} />
                            </span>
                        </div>
                    </div>
                </Popover>
            );
        }

        /**
         * logo
         */
        renderWebLogo(): React.ReactNode {
            const { state } = this.props,
                appConfig = state!.appConfig;

            return appConfig ? (
                <>
                    <img style={{ height: 52 }} src={(appConfig?.webLogo && transformAssetsUrl(appConfig?.webLogo)) || "assets/images/mingtai/footer-logo.png"} />
                </>
            ) : null;
        }

        /**
         * 渲染最上栏
         * @returns
         */
        renderParkAndLogin(): React.ReactNode {
            // const { state } = this.props,
            //     appConfig = state!.appConfig;
            return (
                <div className="nav">
                    <div className="container">
                        <div className="flex">
                            {this.renderWebLogo()}
                            <div className="flex-item">
                                {/*<div className="content-left">
                                    <span className="title">{appConfig ? appConfig?.webName || this.defaultTitle : ""}</span>
                                    <span className="interval">|</span>
                                    {this.renderParks()}
                                </div>*/}
                            </div>
                            <div className="content-right">
                                {this.renderSearch()}
                                {this.isAuth() && (
                                    <a className="head-tag mr30" target="_blank" href={server.webappurl}>
                                        管理后台
                                    </a>
                                )}
                                {this.renderNotice()}
                                {this.renderLogin()}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        /**
         * 获取选中的目录
         * @param menuKey
         * @returns
         */
        getSelectedKeys(menuKey) {
            if (menuKey) {
                return [menuKey];
            }

            const selectedMenuText = getLocalStorage("selectedMenu");

            let selectedMenu = selectedMenuText;

            if (!this.excludeSplit.some((x) => selectedMenuText?.includes(x))) {
                let selectedMenus = selectedMenuText && selectedMenuText.split("?");
                selectedMenu = (selectedMenus && selectedMenus.length > 0 && selectedMenus[0]) || "";
            }

            return [selectedMenu || ""];
        }

        /**
         * 渲染单条目录样式
         * @param key
         * @param link
         * @param event
         * @param title
         * @param [flag]
         * @returns menu item
         */
        renderMenuItem(key, link, event, title, flag?): React.ReactNode {
            return (
                <Menu.Item key={key}>
                    <i className="menu-dot" />
                    <router.Link
                        to={link}
                        className={flag ? "size-18" : ""}
                        onClick={() => {
                            mtaH5Click(event);
                        }}
                    >
                        {title}
                    </router.Link>
                </Menu.Item>
            );
        }

        /**
         * 渲染下拉目录标题
         * @param title
         * @returns
         */
        renderSubMenuTitle(title) {
            return <span className="size-18">{title}</span>;
        }

        /**
         * 点击目录时
         * @param e
         */
        onClickMenu(e) {
            if (e?.keyPath?.length > 0 && e.keyPath[0].includes("?")) {
                this.dispatch({ type: "input", data: { menuKey: e.keyPath[0] } });
            } else {
                this.dispatch({ type: "input", data: { menuKey: null } });
            }
        }
        /**
         * 渲染目录栏
         * @returns
         */
        renderMenu(): React.ReactNode {
            const { state } = this.props,
                menuKey = state!.menuKey,
                parkCode = this.parkCode,
                parkBoolean = state!.parkBoolean,
                selectedKeys: any[] = this.getSelectedKeys(menuKey);
            // openEnterprise = IS_OPEN_ENTERPRISE_HOME,
            // openRecruit = IS_OPEN_RECRUIT;

            return (
                <Menu selectedKeys={selectedKeys} mode="horizontal" className="index-header" onClick={(e) => this.onClickMenu(e)}>
                    {this.renderMenuItem("/home", `/${parkCode}`, statisticsEvent.navigationBarHome, "首页", true)}
                    <SubMenu popupClassName={parkBoolean ? "ipark-menu active" : "ipark-menu"} title={this.renderSubMenuTitle("产业园区")}>
                        <Menu.ItemGroup>
                            {this.renderMenuItem("/investment", `/${parkCode}/investment`, statisticsEvent.navigationBarImpression, "产业招商")}
                            {this.renderMenuItem("/operate", `/${parkCode}/operate`, statisticsEvent.navigationBarActivity, "产业运营")}
                        </Menu.ItemGroup>
                    </SubMenu>
                    {this.renderMenuItem("/construction", `/${parkCode}/construction`, statisticsEvent.navigationBarImpression, "建筑工程", true)}
                    {/*<SubMenu popupClassName="ipark-menu" title={this.renderSubMenuTitle("产业园区")}>*/}
                    {/* <SubMenu popupClassName={parkBoolean ? "ipark-menu active" : "ipark-menu"} title={this.renderSubMenuTitle("核心业务")}>
                        {this.renderMenuItem("/construction", `/${parkCode}/construction`, statisticsEvent.navigationBarImpression, "建筑工程")}
                         <li className="ant-menu-item flex" onClick={() => this.dispatch("input", {parkBoolean: !parkBoolean})}>
                             <div className="flex-item">
                                 <i className="menu-dot" />
                                 <span>产业园区</span>
                             </div>
                             <i className="icon iconxia" />
                         </li>
                         {parkBoolean && <>
                             <Menu.ItemGroup>
                                 {this.renderMenuItem("/investment", `/${parkCode}/investment`, statisticsEvent.navigationBarImpression, "产业招商")}
                                 {this.renderMenuItem("/operate", `/${parkCode}/operate`, statisticsEvent.navigationBarActivity, "产业运营")}
                            </Menu.ItemGroup>
                         </>}
                    </SubMenu> */}
                    {/* <SubMenu popupClassName="ipark-menu" title={this.renderSubMenuTitle("多元业务")}>
                        {this.renderMenuItem("/multicomponent/DCKF", `/${parkCode}/multicomponent/DCKF`, statisticsEvent.navigationBarApplication, "地产开发")}
                        {this.renderMenuItem("/multicomponent/WYFW", `/${parkCode}/multicomponent/WYFW`, statisticsEvent.navigationBarComplaint, "物业服务")}
                        {this.renderMenuItem("/multicomponent/JYWH", `/${parkCode}/multicomponent/JYWH`, statisticsEvent.navigationBarDemand, "教育文化")}
                    </SubMenu> */}

                    {this.renderMenuItem("/partybuilding", `/${parkCode}/partybuilding`, "djservice", "党建引领", true)}
                    {this.renderMenuItem("/activity", `/${parkCode}/activity?sf=3&sq=2`, statisticsEvent.myActivityListView, "活动中心", true)}
                    {this.renderMenuItem("/my", `/${parkCode}/my`, statisticsEvent.navigationBarMy, "个人中心", true)}
                </Menu>
            );
        }

        /**
         * 关键字搜索
         * @param value
         */
        searchKey(value: string) {
            if (value && value.trim()) {
                mtaH5Click(statisticsEvent.globalSearch);
                this.goTo(changeUrlParams(`/${this.parkCode}/heardsearch`, { [CommonSearchParamInUrlEnum.globalKey]: value }));
            } else {
                if (location.pathname.indexOf("heardsearch") > -1) {
                    this.goTo(`/${this.parkCode}`);
                } else {
                    window.location.reload();
                }
            }
        }

        render(): React.ReactNode {
            return (
                <div className={"head-menu " + (this.state.navState ? "hide" : "show")}>
                    <Affix offsetTop={0}>
                        {this.renderParkAndLogin()}
                        <div className="header">
                            <div className="container">
                                <div className="flex width-full">{this.renderMenu()}</div>
                            </div>
                        </div>
                    </Affix>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.header]);
}
